import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';
import ChatComponent from '../components/chat/ChatComponent';
import { resetNotificationDot } from '../util';
import { fetchUserAccountRemote } from '../util/UserAccount';
import { useAuthFetchFromRestAPI } from "../util/api";
import { ITherapist } from "../util/types";
import { useChat } from "../contexts/chat-context";
import ErrorComponent from "../components/ErrorComponent";
import LoadingSpinner from "../components/LoadingSpinner";

const WrapperChat = styled.div`
background: #ffffff;
width : 100%;
height: 100vh;
display: flex;
flex-direction: row;
`;
const ChatPageContainer = () => {
  const { authFetch } = useAuthFetchFromRestAPI();
  const { initConnection } = useChat();

  const [userData, setUserData] = useState<ITherapist | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    resetNotificationDot();
    void load();
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      const userData = await fetchUserAccountRemote(authFetch);
      setUserData(userData);
      await initConnection();
      setError(false);
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  
  if (error) {
    return (
      <ErrorComponent
        callback={load}>
      </ErrorComponent>
    );
  }
  
  return (
    <WrapperChat>
      {loading ?
        <LoadingSpinner /> :
        <ChatComponent therapist={userData}></ChatComponent>
      }
    </WrapperChat>
    );
};
export default memo(ChatPageContainer);
